import { render, staticRenderFns } from "./SlideUpMask.vue?vue&type=template&id=6f250308&scoped=true"
import script from "./SlideUpMask.vue?vue&type=script&lang=js"
export * from "./SlideUpMask.vue?vue&type=script&lang=js"
import style0 from "./SlideUpMask.vue?vue&type=style&index=0&id=6f250308&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f250308",
  null
  
)

export default component.exports